import TransactionsView from './TransactionsView.vue';

export const transactionsRoutes = [
    {
        path: '/transactions',
        name: 'Transactions',
        component: TransactionsView,
        meta: {
            requiresAuth: true,
            accessId: 'transactions',
        }
    }
]
